export class InputAgreementFileToUpload {
    base64: string;
    mimetype: string;
    filename: string;
    file_extension: string;
}